import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const locations = [
  "B-609 EMPIRE BUSINESS HUB",
  "SCIENCE CITY ROAD",
  "OPP SILVER RADIANCE 2",
  "AHMEDABAD 380060",
];

const phones = ["+91 70164 64911", "+91 96244 53445"];

const emails = ["ravinai94@gmail.com", "vishalnai338@gmail.com"];

const socialLinks = [
  { icon: <FaFacebookF size={24} />, url: "https://facebook.com" },
  { icon: <FaInstagram size={24} />, url: "https://instagram.com" },
  { icon: <FaLinkedinIn size={24} />, url: "https://linkedin.com" },
];

const Footer = () => {
  return (
    <footer className="bg-white-500">
      <div className="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Location */}
          <div>
            <h2 className="text-blue-900 text-lg font-medium mb-2">
              OUR LOCATION
            </h2>
            <ul className="text-blue-900 space-y-1">
              {locations.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          {/* Call Us */}
          <div>
            <h3 className="text-blue-900 text-lg font-medium mb-2">
              CALL US
            </h3>
            <ul className="text-blue-900 space-y-2">
              {phones.map((num, i) => (
                <li key={i}>{num}</li>
              ))}
            </ul>
          </div>

          {/* Email Us */}
          <div>
            <h3 className="text-blue-900 text-lg font-medium mb-2">
              EMAIL US
            </h3>
            <ul className="text-blue-900 space-y-2">
              {emails.map((mail, i) => (
                <li key={i}>{mail}</li>
              ))}
            </ul>
          </div>

          {/* Follow Us */}
          <div>
            <h3 className="text-blue-900 text-lg font-medium mb-2">
            FOLLOW US
            </h3>
            <ul className="flex space-x-3">
              {socialLinks.map((social, i) => (
                <li key={i}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-900 hover:text-blue-400 transition-colors duration-200"
                  >
                    {social.icon}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom Line */}
        <div className="mt-4 flex flex-col items-center">
          <hr className="w-full border-gray-400 mb-2" />
          <p className="text-base text-blue-900">
            Copyright &copy; {new Date().getFullYear()} Yug Real Estate Consultancy. 
            All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
